// extracted by mini-css-extract-plugin
export default {"cvError":"Y7-z"};